import { useCallback, useState } from "react";

import client from "../../client";
import handleApiError from "../../../hooks/handleApiError";
import { handleToast } from "../../../utils/functions";

export default function useDeleteSubjectById() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (_category, id) => {
    try {
      setLoading(true);

      const res = await client.delete(`/curriculum/${_category}/${id}`);

      setLoading(false);
      handleToast(res.data?.message);

      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { loading, request };
}
